/* eslint-disable max-len */

import * as React from 'react';

const Backspace: React.FC = () => (
    <svg className="icon" viewBox="0 0 100 100">
        <path
            d="M86.54,29.96v40.07H38.74L15.91,51.01l22.96-21.05H86.54 M91.25,25.25H37.04L8.75,51.18l28.29,23.57h54.21V25.25
    L91.25,25.25z M72.12,41.65l-3.33-3.33l-8.35,8.35l-8.35-8.35l-3.33,3.33L57.1,50l-8.35,8.35l3.33,3.33l8.35-8.35l8.35,8.35
    l3.33-3.33L63.77,50L72.12,41.65z"
        />
    </svg>
);

export default Backspace;
